import React, { useEffect } from 'react'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../components/auth/useAuth'
import { getChatbotLogs } from '../../actions/chatbotActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import Loader from '../../components/loaders/Loader'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'

const formatDate = (date) => {
    return Intl.DateTimeFormat('es-ES', {dateStyle: 'short', timeStyle: 'short', hourCycle: 'h23', timeZone: 'Europe/Madrid'}).format(new Date(date))
}

export default function ChatbotLogs() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { clientauth } = useAuth()

    const { chatbotLogs, loadingLogs } = useSelector(state => state.chatbot)

    useEffect(() => {
        if (clientauth) {
            dispatch(getChatbotLogs())
        }
    }, [dispatch, clientauth])

    const columnsChatbotLogs = [
        {
            name: t('admin.chatbotLogs.title'),
            minWidth: '300px',
            grow: 1,
            cell: datos =>
                <div className="w-100">
                    <div className="d-flex flex-wrap align-items-center gap-2">
                        <span className="text-muted small">
                            <i className="fas fa-clock me-1"></i>{formatDate(datos.createdAt)}
                        </span>
                        <span className="badge bg-secondary">
                            <i className="fas fa-user me-1"></i>{datos.user?.firstname ? `${datos.user.firstname} ${datos.user.lastname || ''}` : datos.user?.email || '-'}
                        </span>
                        <span className="fw-bold">
                            <i className="fas fa-comment-dots me-1"></i>{datos.question}
                        </span>
                    </div>
                    <div className="mt-2 p-2 bg-light rounded" style={{ fontSize: '0.78rem' }}>
                        <ReactMarkdown rehypePlugins={[rehypeRaw]}>{datos.answer}</ReactMarkdown>
                    </div>
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        }
    ]

    const rowStyles = [
        {
            when: () => true,
            style: {
                padding: '14px 8px',
            },
        }
    ]

    return (
        <>
            <div className="toolbar">
                <div className="toolbar-left">
                    <h4>{t('admin.chatbotLogs.title')}</h4>
                </div>
            </div>

            {loadingLogs ? (
                <Loader />
            ) : chatbotLogs?.length > 0 ? (
                <div className="card-simple">
                    <CustomDataTable
                        columns={columnsChatbotLogs}
                        data={chatbotLogs}
                        conditionalRowStyles={rowStyles}
                        pagination={true}
                        exportable={true}
                        printable={true}
                        filter={true}
                    />
                </div>
            ) : (
                <div className="empty-state">
                    <div className="empty-state-icon"><i className="fas fa-comment-dots"></i></div>
                    <div className="empty-state-text">{t('admin.chatbotLogs.thereisnotlogs')}</div>
                </div>
            )}
        </>
    )
}